/*
 * Running Late pop-up
 *
 * Created by Vladimir Shishlyannikov on 27/09/2022.
 * Copyright (c) 2022 iWoo Ltd. All rights reserved.
 */

import React, { useCallback, MouseEvent } from 'react';
import {
  // Text,
  View,
  // ScrollView,
  StyleSheet,
  // TextStyle,
  // ViewStyle,
  // Dimensions,
  // Animated,
  NativeSyntheticEvent, NativeScrollEvent
} from 'react-native';
import clsx from 'clsx';

import Container from '@material-ui/core/Container';

import {
  Button,
  // Dialog,
  // DialogActions,
  // DialogContent,
  // DialogTitle,
  // Divider,
  // FormControl,
  // Grid,
  // Box,
  // InputLabel,
  // MenuItem,
  // Select,
  // TextField,
  Theme,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
// import { inputLabels, Settings } from '../../state/settings/settingsReducer';
// import { useAppState } from '../../state';
// import useRoomState from '../../hooks/useRoomState/useRoomState';

// import RoundedContainer from '../RoundedContainer/RoundedContainer';

// import SlidingUpPanel from 'rn-sliding-up-panel';
// import { Drawer as TruBeDrawer } from '../Drawer/Drawer';

// import CheckOIcon from '../../icons/CheckOIcon';
// import CloseIcon from '../../icons/Close2Icon';

// import { getViewportHeight } from '../../utils';

const useStyles = makeStyles((theme: Theme) => ({
  // container: {
  //   width: '320px',
  //   'min-height': '86px',
  //   padding: '32px 24px 0',
  //   [theme.breakpoints.down('xs')]: {
  //     width: 'calc(100vw - 32px)',
  //   },
  //   '& .inputSelect': {
  //     width: 'calc(100% - 35px)',
  //   },
  // },
  // paper: {
  //   // 'justify-content': 'center',
  //   'align-items': 'center',
  //   [theme.breakpoints.down('xs')]: {
  //     margin: '16px',
  //   },
  // },
  formControl: {
    display: 'block',
    margin: '1.5em 0',
    '&:first-child': {
      margin: '0 0 1.5em 0',
    },
  },
  label: {
    width: '133%', // Labels have scale(0.75) applied to them, so this effectively makes the width 100%
  },
  greyMainColor: {
    color: theme.greyMain,
  },
  button: {
    // float: 'right',
    width: '100%',
  },
  gutterBottom: {
    'padding-bottom': '24px',
  },
  runningLateButton: {
    'flex-grow': 1,
    color: theme.grey,
    'background-color': theme.greyLight,
    // 'border-color':  ''
    'border-color':  theme.grey,
    'border-radius': '8px',
    cursor: 'pointer',
  },
  runningLateButtonActiveState: {
    'border-color':  theme.red,
  },
  closeRunningLatePopup: {
    cursor: 'pointer',
    display: 'flex',
    background: 'transparent',
    border: '0',
    padding: '0',
  },

}));

// const styles = {
//   container: {
//     flex: 1,
//     // 'background-color': 'rgb(255, 255, 255)',
//     'background-color': theme.greyLight,
//     'align-items': 'center',
//     'justify-content': 'center',
//     'border-radius': '8px',
//     height: '100%',
//   },
// };

// type PanelStyle = {
//   backdrop: ViewStyle;
//   container: ViewStyle;
//   // title: TextStyle;
//   // icon: ImageStyle;
// };


// const panelStyles = StyleSheet.create<PanelStyle>({
//   backdrop: {
//     // position: 'fixed',
//     position: 'absolute',
//     'z-index': 1000,
//   },
//   container: {
//     // position: 'fixed',
//     position: 'absolute',
//     'z-index': 1000,
//   },
// });


// interface RunningLatePopupProps {
//   // open: boolean;
//   // onClose(): void;
// }

// const height = getViewportHeight();

// const withDefault = (val?: string) => (typeof val === 'undefined' ? 'default' : val);


export default function RunningLatePopup({
  open,
  refCallback,
  isOpen,
  scrollEnabled,
  onMomentumScrollEnd,
  onClose,
  onSubmit
}: { open: boolean; refCallback?: any; isOpen?: boolean; scrollEnabled?: boolean; onMomentumScrollEnd?: (e: NativeSyntheticEvent<NativeScrollEvent>) => void; onClose: () => void; onSubmit: (e: MouseEvent<HTMLButtonElement>, delayInMinutes?: number) => void; }) {
  const classes = useStyles();
  // const { settings, dispatchSetting } = useAppState();
  // const roomState = useRoomState();
  // const isDisabled = false; // roomState !== 'disconnected';
  const [ activeButton, setActiveButton ] = React.useState();

  // const panelRef = useRef<SlidingUpPanel>(null);

  // React.useEffect(() => {
  //   if (open) {
  //     panelRef.current && panelRef.current.show();
  //   }
  // }, [open]);

  const handleToggleButton = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>, clickedButton) => {
      setActiveButton(clickedButton);
      // dispatchSetting({ name: e.target.name as keyof Settings, value: e.target.value as string });
    },
    []
  );

  const handleCtaClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      // onClose();
      onSubmit(e, activeButton === 0 ? 5 : activeButton === 1 ? 15 : 30);
    },
    [activeButton, onSubmit/*, onClose*/]
  );

  // const handleChange = useCallback(
  //   (e: React.ChangeEvent<{ value: unknown; name?: string }>) => {
  //     dispatchSetting({ name: e.target.name as keyof Settings, value: e.target.value as string });
  //   },
  //   [dispatchSetting]
  // );

  // const handleNumberChange = useCallback(
  //   (e: React.ChangeEvent<{ value: unknown; name?: string }>) => {
  //     if (!/[^\d]/.test(e.target.value as string)) handleChange(e);
  //   },
  //   [handleChange]
  // );

  return (
    <View
      // ref={refCallback}
      // onScroll={onMomentumScrollEnd}
      style={{
        width: '100%',
        height: '100%',
        borderTopRightRadius: 8,
        borderTopLeftRadius: 8,
        backgroundColor: 'rgb(255, 255, 255)',
        // overflow: scrollEnabled ? 'scroll' : 'hidden'
      }}
    >
      <Container style={{ height: '100%' }}>
        <View
          style={{
            justifyContent: "flex-start",
            height: "100%",
            // height: "calc(100% - 66px)",
          }}
        >
          <Typography variant="body1" color="primary" className={clsx( classes.gutterBottom )} style={{ paddingTop: '24px', textAlign: 'center' }}>
            How late will you be?
          </Typography>

          <div
            style={{
              display: "grid",
              height: "calc(100% - 74px)",
              // gridTemplateColumns: "repeat(2, 1fr)",
              gridTemplateRows: "auto 1fr",
              gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
              gridColumnGap: "16px",
              // flexGrow: 1,
              textAlign: "center",
            }}
          >

            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                height: "100%",
                // py={1}
                // px={2}
                flexGrow: 1,
                // 'background-color': 'rgb(255, 255, 255)',
                // padding: '8px 16px',
                // cursor: 'pointer',
                // userSelect: 'none',
                // borderRadius: '8px'
                borderRadius: '8px',
              }}
              // onClick={handleLocationOpenClick}
            >
              <button
                // variant="contained"
                /*className={this.props.classes.buttonsDuet}*/
                className={clsx(classes.runningLateButton, activeButton === 0 && classes.runningLateButtonActiveState)}
                // size="medium"
                // style={{ 'flex-grow': 1 }}
                onClick={e => handleToggleButton(e, 0)}
              >
                <Typography variant="subtitle1" style={{ marginBottom: '4px', color: '#303740' /* .tbk-grey-main */ }}>
                  About
                </Typography>
                <Typography variant="h2" style={{ marginBottom: '4px', color: '#303740' /* .tbk-grey-main */ }}>
                  5
                </Typography>
                <Typography variant="subtitle1" style={{ marginBottom: '4px', color: '#303740' /* .tbk-grey-main */ }}>
                  Minutes
                </Typography>
              </button>
            </div>

            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                height: "100%",
                // py={1}
                // px={2}
                flexGrow: 1,
                // 'background-color': 'rgb(255, 255, 255)',
                // padding: '8px 16px',
                // cursor: 'pointer',
                // userSelect: 'none',
                // borderRadius: '8px'
                borderRadius: '8px',
              }}
              // onClick={handleLocationOpenClick}
            >
              <button
                // variant="contained"
                /*className={this.props.classes.buttonsDuet}*/
                className={clsx(classes.runningLateButton, activeButton === 1 && classes.runningLateButtonActiveState)}
                // size="medium"
                // style={{ 'flex-grow': 1 }}
                onClick={e => handleToggleButton(e, 1)}
              >
                <Typography variant="subtitle1" style={{ marginBottom: '4px', color: '#303740' /* .tbk-grey-main */ }}>
                  About
                </Typography>
                <Typography variant="h2" style={{ marginBottom: '4px', color: '#303740' /* .tbk-grey-main */ }}>
                  15
                </Typography>
                <Typography variant="subtitle1" style={{ marginBottom: '4px', color: '#303740' /* .tbk-grey-main */ }}>
                  Minutes
                </Typography>
              </button>
            </div>

            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                height: "100%",
                // py={1}
                // px={2}
                flexGrow: 1,
                // 'background-color': 'rgb(255, 255, 255)',
                // padding: '8px 16px',
                // cursor: 'pointer',
                // userSelect: 'none',
                // borderRadius: '8px'
                borderRadius: '8px',
              }}
              // onClick={handleLocationOpenClick}
            >
              <button
                // variant="contained"
                /*className={this.props.classes.buttonsDuet}*/
                className={clsx(classes.runningLateButton, activeButton === 2 && classes.runningLateButtonActiveState)}
                // size="medium"
                // style={{
                //   'flex-grow': 1,
                // }}
                onClick={e => handleToggleButton(e, 2)}
              >
                <Typography variant="subtitle1" style={{ marginBottom: '4px', color: '#303740' /* .tbk-grey-main */ }}>
                  About
                </Typography>
                <Typography variant="h2" style={{ marginBottom: '4px', color: '#303740' /* .tbk-grey-main */ }}>
                  30
                </Typography>
                <Typography variant="subtitle1" style={{ marginBottom: '4px', color: '#303740' /* .tbk-grey-main */ }}>
                  Minutes
                </Typography>
              </button>
            </div>


          </div>

          <View style={styles.ctaContainer}>
            <Button
              disabled={!activeButton && activeButton !== 0}
              variant="contained"
              color="primary"
              type="submit"
              onClick={handleCtaClick}
              className={clsx(classes.button)}
            >
              Send
            </Button>
          </View>

        </View>
      </Container>
    </View>
  );
}

const styles = StyleSheet.create({
  ctaContainer: {
    right: '0',
    left: '0',
    position: 'absolute',
    bottom: '0',
    paddingTop: 16,
    paddingBottom: 16,
    backgroundColor: 'rgb(255, 255, 255)',
  }
});
